<template>
  <div>
    <ReportChartRanges
      title="Average commute distance per day"
      queryname="avgCommuteDistanceStatsQuery"
      gettername="avgCommuteDistanceDataAdmin"
      :commutersData="reportData"
      :year="reportYear"
      filter="Miles"
      @setDate="setReportDate"
      @setType="updateType"
      @setWeek="updateWeek"
      :type="type"
      :week="week"
    />
  </div>
  <div>
    <AvgModeMiles
      title="Average commute distance per transportation mode"
      queryname="avgCommuteDistanceModeStatsQuery"
      gettername="avgCommuteModeDistanceDataAdmin"
      :commutersData="reportData2"
      :year="reportYear2"
      :BarTxt="BarTxt2"
      filter="Miles"
      @setDate="setReportDate2"
      @setType="updateModeType"
    />
  </div>
  <StatsAvgDistanceCommuted
    v-if="reportDate"
    :from="reportDate[0]"
    :to="reportDate[1]"
    :key="reportDate[0] + reportDate[1] + type + week + employerSelectedStoreId"
    :type="type"
    :week="week"
    :employer_id="employerSelectedStoreId"
  />
  <StatsAvgModeDistanceCommuted
    v-if="reportDate2"
    :from="reportDate2[0]"
    :to="reportDate2[1]"
    :key="reportDate2[0] + reportDate2[1] + modeType + employerSelectedStoreId"
    :type="modeType"
    :employer_id="employerSelectedStoreId"
  />
</template>

<script>
/* eslint-disable */
import dayjs from 'dayjs';
import StatsAvgDistanceCommuted from '@/services/queries/admin/stats/StatsAvgDistanceCommuted.vue';
import StatsAvgModeDistanceCommuted from '@/services/queries/admin/stats/StatsAvgModeDistanceCommuted.vue';
import ReportChartRanges from './charts/ReportChartRanges.vue';
import AvgModeMiles from './charts/AvgModeMiles.vue';

export default {
  components: {
    ReportChartRanges,
    StatsAvgDistanceCommuted,
    AvgModeMiles,
    StatsAvgModeDistanceCommuted,
  },
  props: {
    queryname: String,
    gettername: String,
    year: Object,
    title: String,
    filter: String,
    commutersData: Object,
    initialData: Object,
  },

  data() {
    return {
      reportYear: dayjs(),
      reportYear2: dayjs(),
      reportDate: null,
      reportDate2: [dayjs().startOf('year').format('YYYY-MM-DD'), dayjs().endOf('year').format('YYYY-MM-DD')],
      type: 'monthly',
      modeType: 'monthly',
      week: 1,
    };
  },
  methods: {
    setReportDate(y) {
      this.reportYear = y;
      const currYear = dayjs(y).year();
      const reportDate = [`${currYear}-01-01`, `${currYear}-12-31`];
      this.reportDate = reportDate;
    },
    setReportDate2(type, index, year) {
      if (type === 1) {
        // For monthly: index represents month (1-12)
        if (index < 1 || index > 12) {
          throw new Error('Monthly index must be between 1 and 12');
        }

        const startDate = dayjs(year)
          .month(index - 1)
          .startOf('month');
        const endDate = dayjs(year)
          .month(index - 1)
          .endOf('month');
        this.reportYear2 = year;
        this.reportDate2 = [startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')];
        return this.reportDate2;
      } else if (type === 2) {
        // For weekly: index represents week number (1-53)
        if (index < 1 || index > 53) {
          // throw new Error('Weekly index must be between 1 and 53');
          index = 53;
        }

        // Start with first day of the year
        const startOfYear = dayjs(year).startOf('year');

        // Calculate the start of the specified week
        // Week 1 is the first week that contains January 1st
        const startDate = startOfYear.add((index - 1) * 7, 'day').startOf('week');
        const endDate = startDate.endOf('week');

        this.reportYear2 = year;
        this.reportDate2 = [startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')];
        return this.reportDate2;
      } else if (type === 3) {
        const startDate = dayjs(year).startOf('year');
        const endDate = dayjs(year).endOf('year');

        this.reportYear2 = year;
        this.reportDate2 = [startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')];
        return this.reportDate2;
      } else {
        const startDate = dayjs(year).startOf('year');
        const endDate = dayjs(year).endOf('year');

        this.reportYear2 = year;
        this.reportDate2 = [startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')];
        return this.reportDate2;
      }
    },
    updateType(typeVal) {
      this.type = typeVal;
    },
    updateModeType(typeVal) {
      this.modeType = typeVal;
    },
    updateWeek(weekVal) {
      this.week = weekVal;
    },
  },
  computed: {
    reportData() {
      return this.$store.getters.avgCommuteDistanceDataAdmin;
    },
    reportData2() {
      return this.$store.getters.avgCommuteModeDistanceDataAdmin;
    },
    employerSelectedStoreId() {
      return this.$store.getters.employerFilterIdData;
    },
    BarTxt2() {
      const [startDate, endDate] = this.reportDate2;

      const start = dayjs(startDate);
      const end = dayjs(endDate);

      return `${start.format('MMM DD YYYY')} - ${end.format('MMM DD YYYY')}`;
    },
  },
  mounted() {
    const currYear = dayjs().year();
    const reportDate = [`${currYear}-01-01`, `${currYear}-12-31`];
    this.reportDate = reportDate;
    const reportDate2 = [dayjs().startOf('month').format('YYYY-MM-DD'), dayjs().endOf('month').format('YYYY-MM-DD')];
    this.reportDate2 = reportDate2;
  },
};
</script>
